import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../assets/icons/logow.png";
import "./my-navbar.styles.css";

// Phase A.5: trimmed nav.
//   Was: Home, About, Experience, Projects, Open Source, Publications,
//        Case Studies, Blog, Now, Skills, Contact, Resume (modal),
//        Resume (PDF) \u2014 13 items, very crowded.
//   Now: Home, About, Work, Experience, Writing*, Open Source, Contact,
//        Resume (PDF) \u2014 8 items.
//   *Writing is a single label that links to /blog (will become /writing
//    in Phase C). Publications and Case Studies are reachable from the
//    About > Explore strip and the home Career Highlights tiles.
const MyNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Navigate to home and scroll to a section. If we're on a sub-page,
  // navigate to "/" first then scroll once it renders.
  const goHomeAnchor = (e, id) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Navbar
      fixed="top"
      variant="dark"
      expand="lg"
      collapseOnSelect
      className="animate-navbar nav-theme justify-content-between"
    >
      <Navbar.Brand as={Link} to="/">
        <img className="logo" src={Logo} alt="Dhruv Agnihotri" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto align-items-lg-center">
          <Nav.Link
            href="/#about"
            onClick={(e) => goHomeAnchor(e, "about")}
          >
            About
          </Nav.Link>
          <Nav.Link
            href="/#Personalprojects"
            onClick={(e) => goHomeAnchor(e, "Personalprojects")}
          >
            Work
          </Nav.Link>
          <Nav.Link
            href="/#experienceTimeline"
            onClick={(e) => goHomeAnchor(e, "experienceTimeline")}
          >
            Experience
          </Nav.Link>
          <Nav.Link as={Link} to="/blog">
            Writing
          </Nav.Link>
          <Nav.Link as={Link} to="/open-source">
            Open Source
          </Nav.Link>
          <Nav.Link
            href="/#contact"
            onClick={(e) => goHomeAnchor(e, "contact")}
          >
            Contact
          </Nav.Link>
          <Nav.Link
            href="/Resume_Dhruv_Agnihotri.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link-resume-pdf"
          >
            Resume {"\u2197"}
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default MyNavbar;
